import { createContext, useContext } from "react";

// A menu open inside the sidenav (the workspace switcher, the account menu)
// keeps it from collapsing under the pointer. SideNavShell provides it. Each
// menu blocks under its own name, so one closing never releases another.
export const CollapseBlockContext = createContext<
  (menu: string, blocked: boolean) => void
>(() => {});
export const useBlockSidenavCollapse = (menu: string) => {
  const setBlocked = useContext(CollapseBlockContext);
  return (blocked: boolean) => setBlocked(menu, blocked);
};
